<template>
  <nav class="site2026-nav">
    <div class="container site2026-nav-inner">
      <a href="/" class="site2026-logo">
        <span class="site2026-logo-mark" aria-hidden="true">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="M17.5 19H9a7 7 0 1 1 1.3-13.9A6 6 0 1 1 17.5 19Z" /></svg>
        </span>
        <span>Bmob</span>
      </a>
      <div class="site2026-nav-cluster">
        <div class="site2026-nav-links">
          <div class="site2026-product-wrap">
            <button type="button" class="site2026-product-btn">产品 <span>▼</span></button>
            <div class="site2026-product-dropdown">
              <div class="site2026-dropdown-grid">
                <a
                  v-for="item in productMenu"
                  :key="item.path"
                  :href="item.path"
                  class="site2026-dropdown-item"
                >
                  <div class="site2026-dropdown-icon" :class="{ 'is-purple': item.purple }" aria-hidden="true" v-html="item.icon" />
                  <div class="site2026-dropdown-content">
                    <h4>
                      {{ item.title }}
                      <span v-if="item.tag" class="site2026-dropdown-tag">{{ item.tag }}</span>
                    </h4>
                    <p>{{ item.desc }}</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <a href="/function" :class="{ active: $route.path === '/function' }">云函数</a>
          <a href="/prices" :class="{ active: $route.path === '/prices' }">价格</a>
          <a href="/ai" :class="{ active: $route.path === '/ai' }">AI 大模型</a>
          <a :href="docUrl" target="_blank">文档</a>
        </div>
        <div class="site2026-nav-right">
          <template v-if="!isLogin">
            <a href="/login">登录</a>
            <a href="/register" class="btn-2026 is-primary">免费开始</a>
          </template>
          <template v-else>
            <a :href="consoleUrl" target="_blank" class="btn-2026 is-primary">我的控制台</a>
          </template>
        </div>
        <button type="button" class="site2026-menu-btn" @click="mobileOpen = !mobileOpen">{{ mobileOpen ? '✕' : '☰' }}</button>
      </div>
    </div>
    <div class="site2026-mobile-menu" :class="{ 'is-open': mobileOpen }">
      <a v-for="item in productMenu" :key="item.path" :href="item.path" class="site2026-mobile-link">{{ item.title }}</a>
      <a class="site2026-mobile-link" href="/function">云函数</a>
      <a class="site2026-mobile-link" href="/prices">价格</a>
      <a class="site2026-mobile-link" href="/ai">AI 大模型</a>
      <a class="site2026-mobile-link" :href="docUrl" target="_blank">文档</a>
      <template v-if="!isLogin">
        <a class="site2026-mobile-link" href="/login">登录</a>
        <a href="/register" class="btn-2026 is-primary" style="margin-top:12px; width:100%;">免费开始</a>
      </template>
      <template v-else>
        <a :href="consoleUrl" target="_blank" class="btn-2026 is-primary" style="margin-top:12px; width:100%;">我的控制台</a>
      </template>
    </div>
  </nav>
</template>

<script>
import { getToken, removeToken } from '@/utils/auth'
import { checkLogin } from '@/api/backend'

export default {
  name: 'Site2026Header',
  data() {
    return {
      isLogin: !!getToken(),
      mobileOpen: false,
      productMenu: [
        {
          title: '云数据库',
          tag: '热门',
          desc: '高性能 NoSQL 云端数据库',
          path: '/cloud',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M3 5v14c0 1.7 4 3 9 3s9-1.3 9-3V5"/><path d="M3 12c0 1.7 4 3 9 3s9-1.3 9-3"/></svg>'
        },
        {
          title: '实时监听',
          tag: '实时',
          desc: 'WebSocket 表/行变更、在线状态与频道广播',
          path: '/realtime',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M4.9 19.1A9 9 0 0 1 2 12C2 6.5 6.5 2 12 2s10 4.5 10 10-4.5 10-10 10"/><path d="M2 12h4"/><path d="M18 12h4"/><path d="M12 2v4"/><path d="M12 18v4"/></svg>'
        },
        {
          title: 'MCP 服务',
          tag: '新',
          desc: '模型上下文协议服务',
          path: '/mcp',
          purple: true,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="6" rx="2"/><rect x="3" y="15" width="18" height="6" rx="2"/><path d="M7 6h.01"/><path d="M7 18h.01"/></svg>'
        },
        {
          title: 'Sites 托管',
          tag: '新',
          desc: '一句话部署 AI 项目，直接上线整站',
          path: '/sites',
          purple: true,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v10"/><path d="m7 10 5 5 5-5"/><path d="M5 21h14"/></svg>'
        },
        {
          title: 'Agent Skills',
          tag: '新',
          desc: '安装技能包，让 AI 自动建表',
          path: '/skills',
          purple: true,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="m8 6 4-4 4 4"/><path d="M12 2v12"/><rect x="4" y="14" width="16" height="8" rx="2"/><path d="M8 18h8"/></svg>'
        },
        {
          title: '物联网 IoT',
          desc: '设备接入与数据管理',
          path: '/iot',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M3 12h18"/><path d="M12 3a14 14 0 0 1 0 18"/><path d="M12 3a14 14 0 0 0 0 18"/></svg>'
        },
        {
          title: 'CodeFlow',
          tag: '新',
          desc: 'AI 驱动的代码生成平台',
          path: '/codeflow',
          purple: true,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M13 2 3 14h7l-1 8 10-12h-7z"/></svg>'
        },
        {
          title: '源码通',
          desc: '精选优质开源项目源码',
          path: '/shop/index',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="m21 8-9-5-9 5 9 5 9-5Z"/><path d="m3 8 9 5 9-5"/><path d="M3 8v8l9 5 9-5V8"/></svg>'
        },
        {
          title: '小程序',
          desc: '多平台小程序解决方案',
          path: '/weixin',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><rect x="7" y="2.5" width="10" height="19" rx="2"/><path d="M11 6h2"/><path d="M12 18h.01"/></svg>'
        },
        {
          title: '短信验证码',
          desc: '快速稳定的短信服务',
          path: '/sms',
          purple: true,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>'
        },
        {
          title: '数据钩子',
          desc: '灵活的数据触发器',
          path: '/hook',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M10 8V5a2 2 0 1 1 4 0v8a6 6 0 1 1-12 0V9"/></svg>'
        },
        {
          title: '鸿蒙 SDK',
          tag: '新',
          desc: '鸿蒙生态开发支持',
          path: '/harmoney',
          purple: true,
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3a9 9 0 1 0 9 9"/><path d="M12 3v6"/><path d="M21 12h-6"/><path d="m17.5 17.5-4.2-4.2"/></svg>'
        },
        {
          title: '提示词广场',
          desc: 'AI 提示词分享社区',
          path: '/prompt',
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z"/></svg>'
        }
      ]
    }
  },
  computed: {
    docUrl() {
      return this.$store.getters.docUrl || 'https://doc.bmob.cn/'
    },
    consoleUrl() {
      const base = process.env.VUE_APP_BASE_URL || ''
      return base + '/app/list'
    }
  },
  watch: {
    $route() {
      this.mobileOpen = false
    }
  },
  mounted() {
    checkLogin().then(res => {
      if (res && res.msg === '用户未登录') {
        this.isLogin = false
        removeToken()
      }
    }).catch(() => {})
  }
}
</script>

<style scoped>
/* 样式统一在 layout/site2026.vue 中全局 import，避免 scoped 隔离破坏 .site2026-* 命名规则 */
</style>
